module.exports = __webpack_public_path__ + "img/bg-intro@3x.31cfb305.png";